import {formatDate, Temporal} from "@/shared/utils/datefunctions";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

export interface TimeAccountIntegrationExportDialogConfig {
	onExport: () => void;
	exportBalances: Temporal.PlainDate[];
	integrationType: string;
}

export class TimeAccountIntegrationExportDialog {
	private readonly dom: JQuery;
	private readonly modal: BootstrapModal.Modal;

	constructor(config: TimeAccountIntegrationExportDialogConfig) {
		this.dom = this.createTemplate();
		this.modal = new BootstrapModal.Modal({
			title: messages.withArguments("report.timeAccountDashboard.export.integration.title", messages["integrations.type." + config.integrationType]),
			message: this.dom,
			destroyOnClose: true,
			buttons: [
				{
					text: "dialog.export",
					action: () => config.onExport(),
					css: "btn-primary absenceExportButton"
				},
				{
					text: "dialog.cancel"
				}
			],
			// needed for the button state, this.modal.getButtons(...) only works after modal DOM exists
			onOpen: () => {
				this.updateNoBalancesState(config.exportBalances.length > 0);
			}
		});
		this.updateExportBalances(config.exportBalances);
	}

	public show() {
		this.modal.show();
	}

	public close() {
		this.modal.close();
	}

	public resetLoadingButtons() {
		this.modal.resetLoadingButtons();
	}

	public getSelectedDate(): string {
		return this.dom.find("#exportTimeAccountIntegrationDate").val() as string;
	}

	public showError(message: string) {
		this.dom.find("#exportTimeAccountIntegrationError")
			.text(message)
			.show();
	}

	private updateExportBalances(exportBalances: Temporal.PlainDate[]) {
		const integrationDateSelect = this.dom.find("#exportTimeAccountIntegrationDate");
		const selectedDate = integrationDateSelect.val() as string;
		integrationDateSelect.empty();
		$.each(exportBalances, function (index, date) {
			const formattedDate = formatDate(date);
			integrationDateSelect.append($("<option></option>", {value: formattedDate}).text(formattedDate));
			if (formattedDate === selectedDate) {
				integrationDateSelect.val(selectedDate);
			}
		});
		this.updateNoBalancesState(exportBalances.length > 0);
	}

	private updateNoBalancesState(hasExportBalances: boolean) {
		this.dom.find("#exportTimeAccountIntegrationInfo").toggle(hasExportBalances);
		this.dom.find("#exportTimeAccountIntegrationNoBalancesWarning").toggle(!hasExportBalances);
		this.modal.getButtons("absenceExportButton").prop("disabled", !hasExportBalances);
	}

	private createTemplate(): JQuery {
		return $(`
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-4 control-label" for="exportTimeAccountIntegrationDate">
						${messages["report.timeAccountDashboard.export.balances"]}
					</label>
					<div class="col-sm-4">
						<select id="exportTimeAccountIntegrationDate" name="date" class="form-control"></select>
					</div>
				</div>
				<div id="exportTimeAccountIntegrationNoBalancesWarning" class="alert alert-warning alert-styled-left" style="display: none">
					${messages["report.timeAccountDashboard.noBalances.error.message"]}
				</div>
				<div id="exportTimeAccountIntegrationError" class="alert alert-danger alert-styled-left" style="display: none"></div>
			</form>
		`);
	}
}
